import { createContext } from "react";
import { CallBack, Case, ReferralDashboardData } from "../../models";

export interface IReferralDashboardContext {
    getDashboardData: () => Promise<void>;
    dashboardData: ReferralDashboardData | undefined;
    mode: "classic" | "new";
    toggleMode: () => void;
    isLoading: boolean;
    handleShowCallBackModal: (callBackId: number) => void;
    handleCloseCallBackModal: () => void;
    showCallBackModal: boolean;
    activeCallBack: CallBack | undefined;
}

const defaultValue: IReferralDashboardContext = {
    getDashboardData: async () => {},
    dashboardData: undefined,
    mode: "classic",
    toggleMode: () => {},
    isLoading: false,
    handleShowCallBackModal: () => {},
    handleCloseCallBackModal: () => {},
    showCallBackModal: false,
    activeCallBack: undefined,
};

export const ReferralDashboardContext = createContext<IReferralDashboardContext>(defaultValue);
ReferralDashboardContext.displayName = "ReferralDashboard";
